import React, { useState } from 'react'
import { Link, Box } from '@mui/material'
import { Drawer } from '..'
import TriggerRenderer from './TriggerRenderer'
import { useTheme } from '@mui/material/styles'

/**
 * CustomMenuDrawer component that renders a drawer with custom HTML content
 *
 * @param {Object} props - Component props
 * @param {Object} props.menuItem - Configuration for the menu item
 * @param {Object} props.menuItem.trigger - Trigger configuration
 * @param {string} props.menuItem.content - HTML content for the drawer
 * @param {Object} props.menuItem.drawerOptions - Optional configuration for the drawer
 * @param {string} props.menuItem.drawerOptions.width - Width of the drawer (default: '400px')
 * @param {string} props.menuItem.drawerOptions.title - Title of the drawer (default: 'Information')
 * @param {boolean} props.menuItem.drawerOptions.sideButton - Whether to show a side button (default: false)
 * @param {string} props.menuItem.drawerOptions.closeIconColor - Color of the close icon (default: '#727272')
 */
const CustomMenuDrawer = ({ menuItem }) => {
    const [open, setOpen] = useState(false)
    const theme = useTheme()
    if (!menuItem || !menuItem.trigger || !menuItem.content) return null

    const { trigger, content, drawerOptions = {} } = menuItem

    const toggleDrawer = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    // Default title if not provided in drawerOptions
    const title = drawerOptions.title || 'Information'

    return (
        <>
            <Link
                underline="none"
                component="button"
                onClick={toggleDrawer}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
            >
                <TriggerRenderer trigger={trigger} />
            </Link>

            <Drawer
                open={open}
                toggleDrawer={toggleDrawer}
                width={drawerOptions.width || 'clamp(40%, 75rem, 70%)'}
                stickyHeader={true}
                closeOnOutsideClick={true}
                iconColor={
                    drawerOptions.closeIconColor ||
                    theme?.palette?.text?.secondary
                }
                header={
                    <Box
                        sx={{
                            padding: '2.4rem 2.4rem',
                            borderBottom: `0.1rem solid ${theme?.palette?.divider}`,
                            fontWeight: 'bold',
                            fontSize: '1.8rem',
                        }}
                    >
                        {title}
                    </Box>
                }
                sx={{
                    padding: '2.4rem 2.4rem',
                    borderBottom: `0.1rem solid ${theme?.palette?.divider}`,
                    fontWeight: 'bold',
                    fontSize: '1.8rem',
                }}
            >
                <Box
                    sx={{
                        padding: '2.4rem',
                        height: '100%',
                        overflow: 'auto',
                    }}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </Drawer>
        </>
    )
}

export default CustomMenuDrawer
